import history from '../../core/history';
import {
  BOOKING_PROCESS_START,
  BOOKING_PROCESS_SUCCESS,
  BOOKING_PROCESS_ERROR,
} from '../../constants';
import { loadAccount } from '../account';
import { userListing as query } from '../../lib/graphql';
import { validatePromoCodeData } from '../siteadmin/PromoCode/managePromoCodeData';

export const bookingProcess = ({
  listId, guests, startDate,
  endDate, preApprove, startTime,
  endTime, options, threadId, promoCode, getInquiry }) => {
  return async (dispatch, getState, { client }) => {

    try {

      if (promoCode) {
        await dispatch(validatePromoCodeData(promoCode));
        const validPromo = getState()?.book?.validPromoCode;
        if (!validPromo) {
          return;
        }
      }

      dispatch({
        type: BOOKING_PROCESS_START,
        payload: {
          bookingLoading: true
        }
      });

      const { data } = await client.query({
        query,
        variables: {
          listId
        },
        fetchPolicy: 'network-only'
      });

      if (data?.UserListing) {
        dispatch({
          type: BOOKING_PROCESS_SUCCESS,
          payload: {
            data: data.UserListing,
            bookDetails: {
              guests,
              startDate,
              endDate,
              preApprove,
              startTime,
              endTime,
              // Selected options: [{ optionId, userInput }] (ids and delivery location, never prices).
              options: options || [],
              threadId,
              getInquiry
            },
            bookingLoading: false
          }
        });
        dispatch(loadAccount());

        history.push('/book/' + listId);
      } else if (data?.UserListing == null) {
        window.location.reload();
      }

    } catch (error) {
      dispatch({
        type: BOOKING_PROCESS_ERROR,
        payload: {
          error,
          bookingLoading: false
        }
      });
      return false;
    }
    return true;
  };
}

// Reloads the listing (prices, options) of the booking in progress without losing the selection.
// Used when the server refuses a booking because options or prices changed meanwhile.
export const refreshBookingListing = (listId) => {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.query({ query, variables: { listId }, fetchPolicy: 'network-only' });
      if (data?.UserListing) {
        dispatch({
          type: BOOKING_PROCESS_SUCCESS,
          payload: {
            data: data.UserListing,
            bookDetails: getState().book?.bookDetails,
            bookingLoading: false
          }
        });
        return true;
      }
    } catch (error) {
      // Keep the current data: the next attempt is validated by the server anyway.
    }
    return false;
  };
};
